

document.addEventListener("DOMContentLoaded", function() {
  document.fonts.ready.then(function() {
    gsap.registerPlugin(ScrollTrigger, SplitText);
       const triggerEl = document.querySelector(".scroll-light-text__inner-wrapper");
  const textEl = document.querySelector(".scroll-light-text__text");

      const splitText = new SplitText(textEl, {
      type: "words,chars",
      charsClass: "line",
      wordsClass: "word"
    }); 

     const tl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        scrub: 1,
         
     start: "top 100%",  // Offset for mobile, tweak as needed
      end: "bottom 80%",
      
     
      }
    });
    tl.to(".line", {
      "--highlight-offset": "100%",
       duration: 1.5,
  ease: "sine.inOut",
  stagger: 0.3
    });

    window.addEventListener("load", ScrollTrigger.refresh);
    window.addEventListener("resize", ScrollTrigger.refresh);
});
});


